import LegalPage from 'components/LegalPage';

import { TEST_ID } from './constants';
import content from './content.md?raw';
import type { FunctionComponent, Props } from './types';

const PrivacyPolicyPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <LegalPage content={content} testId={testId} />
);

export default PrivacyPolicyPage;
